require("./threepl-train-vouchers-table.scss");

import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {TrainVoucher} from "../../models/train-voucher.model";

@Component({
  selector: "app-threepl-train-vouchers-table",
  templateUrl: "./threepl-train-vouchers-table.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplTrainVouchersTableComponent {
  readonly items = input.required<TrainVoucher[]>();
  readonly loading = input(false);

  readonly voucherSelect = output<TrainVoucher>();
  readonly voucherComplete = output<TrainVoucher>();
  readonly voucherCancel = output<TrainVoucher>();
  readonly voucherPrint = output<TrainVoucher>();
  readonly fetchNext = output<void>();
}
